'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../core/view');

var _view2 = _interopRequireDefault(_view);

var _loader = require('./loader.scss');

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoaderView = function (_View) {
  _inherits(LoaderView, _View);

  function LoaderView(config) {
    _classCallCheck(this, LoaderView);

    var _this = _possibleConstructorReturn(this, (LoaderView.__proto__ || Object.getPrototypeOf(LoaderView)).call(this, config));

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.loader,
      'data-hook': 'loader'
    });
    return _this;
  }

  _createClass(LoaderView, [{
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return LoaderView;
}(_view2.default);

LoaderView.extendStyleNames(_loader2.default);

exports.default = LoaderView;
//# sourceMappingURL=loader.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/loader/loader.view.js
// module id = 1702
// module chunks = 1 2 3